module.exports = __webpack_public_path__ + "img/kuwait.07ccc6a2.svg";